function CheckIcon({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path
          d="M17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17C13.4183 17 17 13.4183 17 9Z"
          fill="#79CFA4"
          stroke="white"
          strokeWidth="0.761905"
        />
        <path
          d="M12.8756 6.95507C13.0108 6.81994 13.0108 6.60085 12.8756 6.46571C12.7405 6.33058 12.5214 6.33058 12.3863 6.46571L8.05159 10.8004L6.00659 8.75539C5.87145 8.62026 5.65236 8.62026 5.51723 8.75539C5.38209 8.89052 5.38209 9.10962 5.51723 9.24475L7.8069 11.5344C7.94204 11.6696 8.16113 11.6696 8.29627 11.5344L12.8756 6.95507Z"
          fill="white"
          stroke="white"
          strokeWidth="0.152381"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}

export default CheckIcon;
